import { Component, Prop, Vue } from "vue-property-decorator"
import Icon from "@/core/components/Icon"

@Component
export default class ModuleButton extends Vue {
  @Prop({ default: "" })
  name
  @Prop({ default: "user" })
  icon
  @Prop({ default: "index" })
  route

  render() {
    return (
      <router-link class="w-24" to={{ name: this.route }}>
        <div class="mb-1 flex h-24 items-center justify-center rounded-full bg-gray-light text-green-base">
          <Icon class="h-10 fill-current" icon={this.icon} />
        </div>
        <p class="text-center font-bold text-gray-darker text-xs">
          {this.name}
        </p>
      </router-link>
    )
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: __webpack_exports__, module: module, hotId: "_vue_jsx_hot-53b5afba/ModuleButton.jsx" });